import { UserCircleIcon } from 'tdesign-icons-vue-next';
import { shallowRef } from 'vue';
import { RouteRecordRaw } from 'vue-router';

export default [
  {
    path: '/account-management',
    name: 'accountManagement',
    redirect: '/account-management/organization',
    component: () => import('@/layouts/index.vue'),
    meta: {
      title: '账号管理',
      icon: shallowRef(UserCircleIcon),
      permission: ['RoleList', 'DepartmentList'],
    },
    children: [
      {
        path: 'organization',
        name: 'organization',
        component: () => import('@/pages/account-management/organization.vue'),
        meta: {
          title: '组织架构',
          permission: ['DepartmentList'],
        },
      },
      {
        path: 'role-management',
        name: 'roleManagement',
        component: () => import('@/pages/account-management/role-management.vue'),
        meta: {
          title: '角色管理',
          permission: ['RoleList'],
        },
      },
      {
        path: 'add-member',
        name: 'addMember',
        component: () => import('@/pages/account-management/add-member.vue'),
        meta: {
          title: '添加成员',
          hidden: true,
          permission: ['EmployeeCreate', 'EmployeeEdit'],
          parentRouteName: 'roleManagement',
        },
      },
      {
        path: 'role-permission',
        name: 'rolePermission',
        component: () => import('@/pages/account-management/role-permission.vue'),
        meta: {
          title: '角色权限',
          hidden: true,
          permission: ['RoleEdit'],
          parentRouteName: 'roleManagement',
        },
      },
    ],
  },
] as RouteRecordRaw[];
